import { ReactNode } from "react";
import { Carousel } from "../../Carousel";
import { SectionHeader } from "../../layout/SectionHeader";

interface NewsListProps {
    children: ReactNode;
    title?: string;
    actionButton?: ReactNode;
}

export const NewsList: React.FC<NewsListProps> = ({ children, title, actionButton }) => {
    const onChange = (currentSlide: number) => {
        console.log(currentSlide);
    };

    return (
        <div className="w-full box-border">
            <SectionHeader title={title} actionButton={actionButton} />
            <Carousel onChange={onChange} elementWidth={318}>
                {children}
            </Carousel>
        </div>
    );
}
